import { cn } from '@/lib/utils';
import { LucideIcon, ShieldCheck, Sparkles, Users, Zap } from 'lucide-react';
import React from 'react';

interface SolveItem {
  label: string;
  title: string;
  description: string;
  icon: LucideIcon;
}

const SOLVES: SolveItem[] = [
  {
    label: 'Audience',
    title: 'Vendors and buyers, finally in one place',
    description:
      'No more scattered WhatsApp statuses and group chat screenshots. Every FUTO vendor and buyer meets on one marketplace.',
    icon: Users,
  },
  {
    label: 'Versatility',
    title: 'Compare price and speed across vendors',
    description:
      'See who has it cheapest and who delivers fastest before you commit — side by side, in seconds.',
    icon: Zap,
  },
  {
    label: 'Accessibility',
    title: 'Reach any vendor, any time',
    description:
      "Hostel, lecture hall, off campus — it doesn't matter. Browse and order whenever you need something.",
    icon: Sparkles,
  },
  {
    label: 'Accountability',
    title: 'Verified identity before the first sale',
    description:
      "No vendor sells a single item on Creve until their NIN and school ID have been checked. That's the whole point.",
    icon: ShieldCheck,
  },
];

export const SolvesSection: React.FC = () => {
  return (
    <section className='py-20 sm:py-28'>
      <div className='container'>
        <div className='mx-auto max-w-2xl text-center'>
          <span className='text-xs font-bold uppercase tracking-widest text-primary'>
            What Creve solves
          </span>
          <h2 className='font-heading mt-3 text-3xl font-bold tracking-tight text-foreground sm:text-4xl'>
            Campus commerce, built to be trusted.
          </h2>
        </div>

        <div className='mt-12 grid gap-5 sm:grid-cols-2'>
          {SOLVES.map(({ label, title, description, icon: Icon }, i) => (
            <div
              key={label}
              className={cn(
                'rounded-2xl border border-border bg-card p-7',
                i % 2 === 0 ? 'sm:translate-y-2' : ''
              )}
            >
              <span className='flex h-11 w-11 items-center justify-center rounded-full bg-secondary'>
                <Icon className='h-5 w-5 text-primary' strokeWidth={2.25} />
              </span>
              <p className='mt-5 text-xs font-bold uppercase tracking-widest text-primary'>
                {label}
              </p>
              <h3 className='font-heading mt-2 text-xl font-bold text-foreground'>
                {title}
              </h3>
              <p className='mt-2 text-sm leading-relaxed text-muted-foreground'>
                {description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SolvesSection;
